import { httpCreate } from './http';

const http = httpCreate('/srv/activity-card');

export const activityCard = {
	// 获取卡片列表
	getCardList(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
	/** 新建卡片
	 * @param { Number } data.activityId //直播间id
	 * @param { String } data.picPath	//卡片样式图片
	 * @param { String } data.title	//卡片标题
	 * @param { String } data.link	//跳转链接
	 * @param { Number } data.linkJumpType	//1 直播间内打开 2 外链跳转
	 * @param { Number } data.countdown	//卡片倒计时 秒 0 无倒计时
	 * @param { Number } data.popUpType	//弹出方式 1推送弹出 2进直播间弹出 3观看一定时间弹出 4 每隔一定时间弹出
	 * @param { Number } data.popUpInterval	//弹出间隔（分钟）
	 * @param { Number } data.iconOpenStatus //卡片入口开关
	 * @param { String } data.iconPath	//卡片入口图标
	 * @param { Number } params.isPush // 是否推送 0--不推送 1--推送
	 */
	createCard(data, params) {
		return http.post('', data, { params });
	},
	/** 编辑卡片
	 * @param { Number } cardId // 卡片ID
	 * @param { Number } data.activityId //直播间id
	 * @param { String } data.picPath	//卡片样式图片
	 * @param { String } data.title	//卡片标题
	 * @param { String } data.link	//跳转链接
	 * @param { Number } data.linkJumpType	//1 直播间内打开 2 外链跳转
	 * @param { Number } data.countdown	//卡片倒计时 秒 0 无倒计时
	 * @param { Number } data.popUpType	//弹出方式 1推送弹出 2进直播间弹出 3观看一定时间弹出 4 每隔一定时间弹出
	 * @param { Number } data.popUpInterval	//弹出间隔（分钟）
	 * @param { Number } data.iconOpenStatus //卡片入口开关
	 * @param { String } data.iconPath	//卡片入口图标
	 * @param { Number } params.isPush // 是否推送 0--不推送 1--推送
	 * @returns
	 */
	editCard(cardId, data, params) {
		return http.put(`/${cardId}`, data, { params });
	},
	// 推送卡片
	pushCard(cardId) {
		return http.post(`/push/${cardId}`);
	},
	// 取消推送卡片
	cancelPushCard(cardId) {
		return http.post(`/cancel/${cardId}`);
	},
	// 删除卡片
	deleteCard(cardId) {
		return http.delete(`/${cardId}`);
	},
};
